<template>
  <div class="details">
      <b-form>
          <!-- personal details -->
          <h2>Personal Details</h2>
          <!-- Address -->
          <div class="address-update">
            <p>The address that we currently have on file is displayed below. If your address has changed, please click the update address button to amend. <span class="address-warning-text">(Please ensure you save your progress before updating your address)</span></p>
            <p>{{ address1 }}</p>
            <p>{{ address2 }}</p>
            <p>{{ address3 }}</p>
            <p>{{ address4 }}</p>
            <p>{{ postcode.toUpperCase() }}</p>
            <b-button 
              variant="primary"
              @click="handleOpenAddressUpdateModal"
              >
              Amend Address
            </b-button>
          </div>
          <!-- Choice of first name -->
          <b-form-group
                  class="mt-4"
                  label="What first name do you want to appear on your phone id, system log-ins, badge, business cards etc. Eg are you Andrew or Andy, Rebecca or Becky? Recognised abbreviations of names only, no nicknames"
          >
              <b-form-input
                      :class="{
          'is-valid': !$v.form.chosenName.$error && form.chosenName,
          'is-invalid': $v.form.chosenName.$error
        }"
                      :value="form.chosenName"
                      @input="handleInput('chosenName', $event)"
              >

              </b-form-input>

          </b-form-group>

          <!-- Title -->
        <b-form-group
        class="mt-4"
        label="Title"
        >
        <b-form-select
          :value="form.title"
          :options="titleOpts"
          @change="handleInput('title', $event)"
          :class="{
            'is-valid': !$v.form.title.$error && form.title,
            'is-invalid': $v.form.title.$error
          }"
        ></b-form-select>
        </b-form-group>
          
          <!-- 1st Forename -->
          <b-form-group
            class="mt-4"
            label="First Forename"
          >
            <b-form-input
              :value="form.firstForeName"
              @input="handleInput('firstForeName', $event)"
              :class="{
            'is-valid': !$v.form.firstForeName.$error && form.firstForeName,
            'is-invalid': $v.form.firstForeName.$error
              }"
            >
          </b-form-input>

          </b-form-group>

          <!-- 2nd Forename -->
            <b-form-group
              class="mt-4"
              label="Second Forename"
              >
              <b-form-input
                :value="form.secondForeName"
                @input="handleInput('secondForeName', $event)"
              >
              </b-form-input>
          </b-form-group>

          <!-- Middle names -->
          <b-form-group
            class="mt-4"
            label="Middle Name(s)"
          >
              <b-form-input
                :value="form.middleNames"
                @input="handleInput('middleNames', $event)"
              >

              </b-form-input>

          <!-- Surname -->
          <b-form-group
            class="mt-4"
            label="Surname"
          >
            <b-form-input
              :value="form.surname"
              @input="handleInput('surname', $event)"
              :class="{
            'is-valid': !$v.form.surname.$error && form.surname,
            'is-invalid': $v.form.surname.$error
              }"
            >
          </b-form-input>

          </b-form-group>

          </b-form-group>
          <!-- Nationality -->
          <b-form-group
                  class="mt-4"
                  label="Nationality"
          >
              <b-form-input
                      :class="{
          'is-valid': !$v.form.nationality.$error && form.nationality,
          'is-invalid': $v.form.nationality.$error
        }"
                      :value="form.nationality"
                      @input="handleInput('nationality', $event)"
              >

              </b-form-input>

          </b-form-group>
          <!-- Date of Birth -->
          <b-form-group
                  label="Date of Birth"
          >
              <b-form-input
                      :class="{
          'is-valid': !$v.form.DOB.$error && form.DOB,
          'is-invalid': $v.form.DOB.$error
        }"
                      :value="form.DOB"
                      type="date"
                      @input="handleInput('DOB', $event)"
              >

              </b-form-input>

          </b-form-group>
          <!-- Sex -->
          <b-form-group label="Sex">
              <div class="radio radio-custom">
                  <input id="sexMale"
                         v-model="sex"
                         name="sex"
                         type="radio"
                         value="Male"
                         @change="handleInput('sex', sex)"
                  >
                  <label for="sexMale">Male</label>
              </div>
              <div class="radio radio-custom">
                  <input id="sexFemale"
                         v-model="sex"
                         name="sex"
                         type="radio"
                         value="Female"
                         @change="handleInput('sex', sex)"
                  >
                  <label for="sexFemale">Female</label>
              </div>
          </b-form-group>

           <!-- National Insurance or PPS No -->
            <b-form-group
              :label="referer === 'UK' ? 'National Insurance Number' : 'PRSI Number'"
            >
             <b-form-input
                :value="form.nationalInsurance"
                @input="handleInput('nationalInsurance', $event)"
                :class="{
                'is-valid': !$v.form.nationalInsurance.$error && form.nationalInsurance,
                'is-invalid': $v.form.nationalInsurance.$error
                }"
              ></b-form-input>
            </b-form-group>
          <hr class="my-5">
          <!-- Next of kin details -->
          <h4 class="mt-5">Next of Kin - (The person(s) you want us to contact in case of emergency)</h4>
          <p>Please provide the name and address of two persons you want us to contact in case of emergency.</p>
          <!-- NEW NEXT OF KIN -->
          <b-card
            bg-variant="light"
            class="mb-4"
          >
            <h5>Next of kin 1</h5>
            <!-- Full name -->
            <b-form-group
              label="Full Name"
            >
              <b-form-input
                :value="form.NOK1Fullname"
                @input="handleInput(`NOK1Fullname`, $event)"
                :class="{
                  'is-valid': !$v.form.NOK1Fullname.$error && form.NOK1Fullname,
                  'is-invalid': $v.form.NOK1Fullname.$error 
                }"
              />
            </b-form-group>
            <!-- Relationship -->
            <b-form-group
              label="Relationship"
            >
              <b-form-input
                :value="form.NOK1Relationship"
                @input="handleInput('NOK1Relationship', $event)"
                :class="{
                  'is-valid': !$v.form.NOK1Relationship.$error && form.NOK1Relationship,
                  'is-invalid': $v.form.NOK1Relationship.$error 
                }"
              >
              </b-form-input>
            </b-form-group>
            <!-- UK Postcode lookup -->
            <p class=""><b>Address Details</b></p>
            <p>Please enter your next of kins address details below by either searching using the postcode finder or manually typing into the fields below.</p>
            <UkPostcode
              :formName="formName"
              addressOwner="NOK"
              labelText="Home Address - Enter postcode"
              placeholderText="Postcode Finder"
              @postcodeSelected="(e) => handleAddressSelect(e, 'NOK1')"
            />
            <!-- EIRCODE LOOKUP -->
            <b-form-group v-if="referer === 'IE'">
              <Autoaddress
                licencekey="2e9c9e91-eda5-472e-ae24-7d3569bec687"
                vanityMode="true"
                addressProfile="Demo5LineV2"
                country="ie"
                language="en"
                noResultFoundLabel="No search results have been found.Please enter address manually below."
                @onAddressFound="handleAddressSelect($event, 'NOK1')"
                placeHolderLabel="Enter Eircode"
              />
            </b-form-group>
            <!-- Address Line 1 -->
            <b-form-group>
              <b-form-input
                :value="form.NOK1Address1"
                @input="handleInput('NOK1Address1', $event)"
                placeholder="Address Line 1*"
                :class="{
                  'is-valid': !$v.form.NOK1Address1.$error && form.NOK1Address1,
                  'is-invalid': $v.form.NOK1Address1.$error 
                }"
              ></b-form-input>
            </b-form-group>
            <!-- Address Line 2 -->
            <b-form-group>
              <b-form-input
                :value="form.NOK1Address2"
                @input="handleInput('NOK1Address2', $event)"
                placeholder="Address Line 2"
              ></b-form-input>
            </b-form-group>
            <!-- Address Line 3 -->
            <b-form-group>
              <b-form-input
                :value="form.NOK1Address3"
                @input="handleInput('NOK1Address3', $event)"
                placeholder="Address Line 3"
              ></b-form-input>
            </b-form-group>
            <!-- Address Line 4 -->
            <b-form-group>
              <b-form-input
                :value="form.NOK1Address4"
                @input="handleInput('NOK1Address4', $event)"
                placeholder="Address Line 4"
              ></b-form-input>
            </b-form-group>
            <!-- Postcode -->
            <b-form-group>
              <b-form-input
                :value="form.NOK1Postcode"
                @input="handleInput('NOK1Postcode', $event)"
                placeholder="Postcode*"
                :class="{
                  'is-valid': !$v.form.NOK1Postcode.$error && form.NOK1Postcode,
                  'is-invalid': $v.form.NOK1Postcode.$error 
                }"
              ></b-form-input>
            </b-form-group>
            <!-- Daytime phone -->
            <b-form-group
              label="Daytime Phone Number"
            >
            <b-form-input
              type="number"
              :value="form.NOK1DayNumber"
              @input="handleInput('NOK1DayNumber', $event)"
            >
          </b-form-input>
        </b-form-group>
        <!-- Evening phone -->
        <b-form-group
          label="Evening Phone Number"
        >
          <b-form-input
            type="number"
            :value="form.NOK1EveningNumber"
            @input="handleInput('NOK1EveningNumber', $event)"
          >
          </b-form-input>
        </b-form-group>
        <!-- Mobile Phone -->
        <b-form-group
          label="Mobile Number"
        >
          <b-form-input
            type="number"
            :value="form.NOK1MobileNumber"
            @input="handleInput('NOK1MobileNumber', $event)"
            :class="{
              'is-valid': !$v.form.NOK1MobileNumber.$error && form.NOK1MobileNumber,
              'is-invalid': $v.form.NOK1MobileNumber.$error 
            }"
          >
        </b-form-input>
      </b-form-group>
    </b-card>
    <b-card
      bg-variant="light"
      class="mb-4"
    >
      <h5>Next of kin 2</h5>
      <!-- Full name -->
      <b-form-group
        label="Full Name"
      >
        <b-form-input
          :value="form.NOK2Fullname"
          @input="handleInput(`NOK2Fullname`, $event)"
          :class="{
            'is-valid': !$v.form.NOK2Fullname.$error && form.NOK2Fullname,
            'is-invalid': $v.form.NOK2Fullname.$error 
          }"
        />
      </b-form-group>
      <!-- Relationship -->
      <b-form-group
        label="Relationship"
      >
        <b-form-input
          :value="form.NOK2Relationship"
          @input="handleInput('NOK2Relationship', $event)"
          :class="{
            'is-valid': !$v.form.NOK2Relationship.$error && form.NOK2Relationship,
            'is-invalid': $v.form.NOK2Relationship.$error 
          }"
        >
        </b-form-input>
      </b-form-group>
      <!-- UK Postcode lookup -->
      <p class=""><b>Address Details</b></p>
      <p>Please enter your next of kins address details below by either searching using the postcode finder or manually typing into the fields below.</p>
      <UkPostcode
        :formName="formName"
        addressOwner="NOK"
        labelText="Home Address - Enter postcode"
        placeholderText="Postcode Finder"
        @postcodeSelected="(e) => handleAddressSelect(e, 'NOK2')"
      />
      <!-- EIRCODE LOOKUP -->
      <b-form-group v-if="referer === 'IE'">
        <Autoaddress
          licencekey="2e9c9e91-eda5-472e-ae24-7d3569bec687"
          vanityMode="true"
          addressProfile="Demo5LineV2"
          country="ie"
          language="en"
          noResultFoundLabel="No search results have been found.Please enter address manually below."
          @onAddressFound="handleAddressSelect(e, 'NOK2')"
          placeHolderLabel="Enter Eircode"
        />
      </b-form-group>
      <!-- Address Line 1 -->
      <b-form-group>
        <b-form-input
          :value="form.NOK2Address1"
          @input="handleInput('NOK2Address1', $event)"
          placeholder="Address Line 1*"
          :class="{
            'is-valid': !$v.form.NOK2Address1.$error && form.NOK2Address1,
            'is-invalid': $v.form.NOK2Address1.$error 
          }"
        ></b-form-input>
      </b-form-group>
      <!-- Address Line 2 -->
      <b-form-group>
        <b-form-input
          :value="form.NOK2Address2"
          @input="handleInput('NOK2Address2', $event)"
          placeholder="Address Line 2"
        ></b-form-input>
      </b-form-group>
      <!-- Address Line 3 -->
      <b-form-group>
        <b-form-input
          :value="form.NOK2Address3"
          @input="handleInput('NOK2Address3', $event)"
          placeholder="Address Line 3"
        ></b-form-input>
      </b-form-group>
      <!-- Address Line 4 -->
      <b-form-group>
        <b-form-input
          :value="form.NOK2Address4"
          @input="handleInput('NOK2Address4', $event)"
          placeholder="Address Line 4"
        ></b-form-input>
      </b-form-group>
      <!-- Postcode -->
      <b-form-group>
        <b-form-input
          :value="form.NOK2Postcode"
          @input="handleInput('NOK2Postcode', $event)"
          placeholder="Postcode*"
          :class="{
            'is-valid': !$v.form.NOK2Postcode.$error && form.NOK2Postcode,
            'is-invalid': $v.form.NOK2Postcode.$error 
          }"
        ></b-form-input>
      </b-form-group>
      <!-- Daytime phone -->
      <b-form-group
        label="Daytime Phone Number"
      >
        <b-form-input
          type="number"
          :value="form.NOK2DayNumber"
          @input="handleInput('NOK2DayNumber', $event)"
        >
        </b-form-input>
      </b-form-group>
      <!-- Evening phone -->
      <b-form-group
        label="Evening Phone Number"
      >
        <b-form-input
          type="number"
          :value="form.NOK2EveningNumber"
          @input="handleInput('NOK2EveningNumber', $event)"
        >
        </b-form-input>
      </b-form-group>
      <!-- Mobile Phone -->
      <b-form-group
        label="Mobile Number"
      >
        <b-form-input
          type="number"
          :value="form.NOK2MobileNumber"
          @input="handleInput('NOK2MobileNumber', $event)"
          :class="{
            'is-valid': !$v.form.NOK2MobileNumber.$error && form.NOK2MobileNumber,
            'is-invalid': $v.form.NOK2MobileNumber.$error 
          }"
        >
        </b-form-input>
      </b-form-group>
    </b-card>
        <hr class="my-5">
        <!-- Furhter details -->
          <h4>Further Information</h4>
          <!-- Any children -->
          <p class="mt-4">Do you have any children?</p>
          <b-form-group>
              <div class="radio radio-custom">
                  <input id="childrenYes"
                         v-model="children"
                         name="children"
                         type="radio"
                         value="Children Yes"
                         @change="handleInput('children', children)"
                  >
                  <label for="childrenYes">Yes</label>
              </div>
              <div class="radio radio-custom">
                  <input id="childrenNo"
                         v-model="children"
                         name="children"
                         type="radio"
                         value="Children No"
                         @change="handleInput('children', children)"
                  >
                  <label for="childrenNo">No</label>
              </div>
          </b-form-group>
          <!-- Details -->
          <div v-if="children === 'Children Yes'">
              <p>Please provide their names and dates of birth. You can add as many children as you like by clicking
                  the add child button below.</p>
              <div v-for="(item, index) in childrenDetails" :key="index">
                  <b-card bg-variant="light" class="mb-4">
                      <h5>Child {{ index + 1 }}</h5>
                      <Children :index="index" :section="item"/>
                  </b-card>
              </div>
              <!-- Add child option -->
              <div>
                  <span>
                      <b-button size="sm" variant="success" @click="addChild">Add child</b-button>
                  </span>
                  <span v-if="childrenDetails.length>1">
                      <b-button class="ml-4" size="sm" variant="danger" @click="removeChild()">Remove</b-button>
                  </span>
              </div>
          </div>

          <!-- Any dependents -->
          <p class="mt-5 mb-2">Do you have any dependants?</p>
          <p>(A dependant is the husband/wife/child/parent of an employee)</p>
          <b-form-group>
              <div class="radio radio-custom">
                  <input id="dependantYes"
                         v-model="dependant"
                         name="dependant"
                         type="radio"
                         value="Dependant Yes"
                         @change="handleInput('dependant', dependant)"
                  >
                  <label for="dependantYes">Yes</label>
              </div>
              <div class="radio radio-custom">
                  <input id="dependantNo"
                         v-model="dependant"
                         name="dependant"
                         type="radio"
                         value="Dependant No"
                         @change="handleInput('dependant', dependant)"
                  >
                  <label for="dependantNo">No</label>
              </div>
          </b-form-group>
          <!-- Details -->
          <div v-if="dependant === 'Dependant Yes'">
              <p>Please provide their names & relationship. You can add as
                  many dependants as you like by clicking the add dependant button below.</p>
              <p>(If you listed Children above there is no need to repeat the information)</p>
              <div v-for="(item, index) in dependantDetails" :key="index">
                  <b-card bg-variant="light" class="mb-4">
                      <Dependant :index="index" :section="item"/>
                  </b-card>
              </div>
              <!-- Add dependant option -->
              <div>
                  <span>
                      <b-button size="sm" variant="success" @click="addDependant">Add dependant</b-button>
                  </span>
                  <span v-if="dependantDetails.length>1">
                      <b-button class="ml-4" size="sm" variant="danger" @click="removeDependant">Remove</b-button>
                  </span>
              </div>
          </div>
          <!-- LEave -->
          <p class="mt-4">Have you taken any dependants/maternity/paternity/parental leave in the last 12 months?</p>
          <b-form-group>
              <div class="radio radio-custom">
                  <input id="dependantLeaveYes"
                         v-model="dependantLeave"
                         :value="`Dependant leave yes`"
                         name="dependantLeave"
                         type="radio"
                         @change="handleInput('dependantLeave', dependantLeave)"
                  >
                  <label for="dependantLeaveYes">Yes</label>
              </div>
              <div class="radio radio-custom">
                  <input id="dependantLeaveNo"
                         v-model="dependantLeave"
                         :value="`Dependant leave no`"
                         name="dependantLeave"
                         type="radio"
                         @change="handleInput('dependantLeave', dependantLeave)"
                  >
                  <label for="dependantLeaveNo">No</label>
              </div>
          </b-form-group>
          <hr class="my-5">

          <!-- LAnguages -->
          <!-- <h4 class="mt-5">Languages</h4>
          <b-form-group
                  label="Are there any languages in which you feel yourself to be sufficiently fluent to discuss travel arrangements with clients?"
          >
              <p>(Please note that this may include the use of technical terminology).</p>
              <b-form-textarea
                      :value="form.languages"
                      @input="handleInput('languages', $event)"
              ></b-form-textarea>
          </b-form-group>
          <hr class="my-5"> -->

          <!-- Health -->
          <h2>Health</h2>
          <b-form-group
            label="Do you have any health and/or medical conditions we should be aware of?"
          >
            <p>(eg diabetes, allergy to Aspirin etc).</p>
            <b-form-textarea
              :value="form.health"
              @input="handleInput('health', $event)"
            ></b-form-textarea>
          </b-form-group>
          <!-- Convictions -->

          <h4>Criminal Convictions</h4>
          <p>Do you have any unspent criminal convictions?</p>
          <b-form-group>
              <div class="radio radio-custom">
                  <input id="criminalConvictionsYes"
                         v-model="criminalConvictions"
                         name="criminalConvictions"
                         type="radio"
                         value="Have Convictions"
                         @change="handleInput('criminalConvictions', criminalConvictions)"
                  >
                  <label for="criminalConvictionsYes">Yes</label>
              </div>
              <div class="radio radio-custom">
                  <input id="criminalConvictionsNo"
                         v-model="criminalConvictions"
                         name="criminalConvictions"
                         type="radio"
                         value="No Convictions"
                         @change="handleInput('criminalConvictions', criminalConvictions)"
                  >
                  <label for="criminalConvictionsNo">No</label>
              </div>
          </b-form-group>
          <div v-if="criminalConvictions === 'Have Convictions'">
              <b-form-group
                      label="If you have answered yes please provide full details"
              >
                  <b-form-textarea
                          :value="form.convictionDetails"
                          @input="handleInput('convictionDetails', $event)"
                  ></b-form-textarea>
              </b-form-group>
          </div>
          <hr class="my-5">

          <!-- Referees -->
          <h4>Referees</h4>
          <p>Please provide details of your last employer.</p>
          <!-- Full name -->
          <b-form-group
                  label="Full Name"
          >
              <b-form-input
                      :class="{
          'is-valid': !$v.form.refereeName.$error && form.refereeName,
          'is-invalid': $v.form.refereeName.$error
        }"
                      :value="form.refereeName"
                      @input="handleInput('refereeName', $event)"
              >

              </b-form-input>

          </b-form-group>
          <!-- Company name -->
          <b-form-group
                  label="Company Name"
          >
              <b-form-input
                      :class="{
          'is-valid': !$v.form.refereeCompany.$error && form.refereeCompany,
          'is-invalid': $v.form.refereeCompany.$error
        }"
                      :value="form.refereeCompany"
                      @input="handleInput('refereeCompany', $event)"
              >

              </b-form-input>

          </b-form-group>
          <!-- Job title -->
          <b-form-group
                  label="Job Title"
          >
              <b-form-input
                      :class="{
          'is-valid': !$v.form.refereeJobTitle.$error && form.refereeJobTitle,
          'is-invalid': $v.form.refereeJobTitle.$error
        }"
                      :value="form.refereeJobTitle"
                      @input="handleInput('refereeJobTitle', $event)"
              >

              </b-form-input>

          </b-form-group>
          <!-- Email Address -->
          <b-form-group
                  label="Email Address"
          >
              <b-form-input
                      :class="{
          'is-valid': !$v.form.refereeEmail.$error && form.refereeEmail,
          'is-invalid': $v.form.refereeEmail.$error
        }"
                      :value="form.refereeEmail"
                      @input="handleInput('refereeEmail', $event)"
              >

              </b-form-input>

          </b-form-group>
          <!-- Disclaimer -->
          <div class="disclaimer">
              <p>The information supplied on this form will be used as the basis of your staff record.</p>
          </div>
      </b-form>
      <AddressUpdateModal ref="addressUpdateModal" />
  </div>
</template>

<script>
import Children from './formSubComponents/Children.vue'
import Dependant from './formSubComponents/Dependant.vue'
import {mapActions, mapGetters, mapState} from 'vuex'
import {required, email} from 'vuelidate/lib/validators'
import {updateForm, selectPostcode} from '../../helpers/index'
import Autoaddress from '@autoaddress.ie/autoaddress-vue/src/Autoaddress'
import UkPostcode from '../UkPostcode.vue'
import AddressUpdateModal from '../modals/addressUpdateModal.vue'

export default {
components: {
  Children,
  Dependant,
  Autoaddress,
  UkPostcode,
  AddressUpdateModal
},
computed: {
  ...mapGetters({
    getRecruit: 'authStore/getRecruit'
  }),
  ...mapState({form: state => state.authStore.recruit.onboarding.onboardingForms.detailsForm}),
},
data() {
  return {
    formName: 'detailsForm',
    postcodeLookup: '',
    postcodeResult: '',
    referer: window.siteVar.referer,
    nextOfKin: [],
    children: '',
    childrenDetails: [],
    dependant: '',
    dependantDetails: [],
    dependantLeave: '',
    firstAid: '',
    appointedFirstAid: '',
    criminalConvictions: '',
    sex: '',
    address1: '',
    address2: '',
    address3: '',
    address4: '',
    postcode: '',
    titleOpts: [{ text: 'Please select', value: null }, 'Mr', 'Mrs', 'Miss', 'Ms', 'Dr', 'Other'],
  }
},
mounted() {
  this.$v.$touch()
  setTimeout(() => {
    this.nextOfKin = this.getRecruit.onboarding.onboardingForms.detailsForm.nextOfKin
    this.address1 = this.getRecruit.address1
    this.address2 = this.getRecruit.address2
    this.address3 = this.getRecruit.address3
    this.address4 = this.getRecruit.address4
    this.postcode = this.getRecruit.postcode
    if (!this.nextOfKin.length) {
      this.addNextOfKin()
    }
    this.children = this.form.children
    this.childrenDetails = this.getRecruit.onboarding.onboardingForms.detailsForm.childrenDetails
    this.dependant = this.form.dependant
    this.dependantDetails = this.getRecruit.onboarding.onboardingForms.detailsForm.dependantDetails
    this.dependantLeave = this.form.dependantLeave
    this.firstAid = this.form.firstAid
    this.appointedFirstAid = this.form.appointedFirstAid
    this.criminalConvictions = this.form.criminalConvictions
    this.sex = this.form.sex
  }, 1000)
},
updated() {
  const validationData = {
    section: 'details',
    status: !this.$v.form.$invalid
  }
  this.updateOnboardingCompleteAction(validationData)
},
methods: {
  ...mapActions({
    selectAddressAction: 'authStore/selectAddressAction',
    updateOnboardingFormAction: 'authStore/updateOnboardingFormAction',
    currentOnboardingFormAction: 'authStore/currentOnboardingFormAction',
    setRecruitAction: 'authStore/setRecruitAction',
    createNextOfKinAction: 'authStore/createNextOfKinAction',
    removeNextOfKinAction: 'authStore/removeNextOfKinAction',
    createChildAction: 'authStore/createChildAction',
    removeChildAction: 'authStore/removeChildAction',
    createDependantAction: 'authStore/createDependantAction',
    removeDependantAction: 'authStore/removeDependantAction',
    updateOnboardingCompleteAction: 'authStore/updateOnboardingCompleteAction',
    setNextOfKinAddressAction: 'authStore/setNextOfKinAddressAction'

  }),
  handleInput(input, e, nested, array, index, item) {
    this.updateForm(input, e, nested, array, index, item)
    if (e === 'Children Yes') {
      if (this.childrenDetails.length === 0) {
        this.addChild();
      }
    }
    if (e === 'Dependant Yes') {
      if (this.dependantDetails.length === 0) {
        this.addDependant();
      }
    }
  },
  handlePostcode(address, addressOwner, isArray, index, input) {
    this.selectPostcode(address, addressOwner, isArray, index, input)
  },
  addNextOfKin() {
    this.createNextOfKinAction()
  },
  removeNextOfKin() {
    this.removeNextOfKinAction(this.nextOfKin.length - 1)
  },
  addChild() {
    this.createChildAction()
  },
  removeChild() {
    this.removeChildAction(this.childrenDetails.length - 1)
  },
  addDependant() {
    this.createDependantAction()
  },
  removeDependant() {
    this.removeDependantAction(this.dependantDetails.length-1)
  },
  handleAddressSelect (e, prefix) {
    const addressArray = e && e.address ? e.address.split(',') : e.postalAddress
    const postcode = e.postcode
    const addressData = {
      prefix,
      address1: addressArray && addressArray.length && addressArray[0] ? addressArray[0].trim() : '',
      address2: addressArray && addressArray.length && addressArray[1] ? addressArray[1].trim() : '',
      address3: addressArray && addressArray.length && addressArray[2] ? addressArray[2].trim() : '',
      address4: addressArray && addressArray.length && addressArray[3] ? addressArray[3].trim() : '',
      postcode
    }
    this.setNextOfKinAddressAction(addressData)
  },
  handleOpenAddressUpdateModal () {
    const addressData = {
      address1: this.address1,
      address2: this.address2,
      address3: this.address3,
      address4: this.address4,
      postcode: this.postcode
    }
    this.$refs.addressUpdateModal.openModal(addressData)
  },
  updateForm,
  selectPostcode
},
validations() {
  return {
    form: {
      title: {
        required: required
      },
      firstForeName: {
        required: required
      },
      surname: {
        required: required
      },
      chosenName: {
        required: required
      },
      nationality: {
        required: required
      },
      DOB: {
        required: required
      },
      refereeName: {
        required: required
      },
      refereeCompany: {
        required: required
      },
      refereeJobTitle: {
        required: required
      },
      refereeEmail: {
        required: required,
        email: email
      },
      NOK1Fullname: {
        required: required
      },
      NOK1Relationship: {
        required: required
      },
      NOK1Address1: {
        required: required
      },
      NOK1Postcode: {
        required: required
      },
      NOK1MobileNumber: {
        required: required
      },
      NOK2Fullname: {
        required: required
      },
      NOK2Relationship: {
        required: required
      },
      NOK2Address1: {
        required: required
      },
      NOK2Postcode: {
        required: required
      },
      NOK2MobileNumber: {
        required: required
      },
      nationalInsurance: {
        required: required
      }
    }
  }
}
}
</script>

<style scoped>
.address-update {
padding: 10px;
background-color: #e9e9e9;
}
.address-warning-text {
font-weight: bold;
color: #fc333a;
}
</style>
